import { defineStore } from 'pinia'
import { readStored, writeStored } from '@/utils/storage'

export type Locale = 'cs' | 'en'

/** `system` follows the operating system's light or dark setting until the user picks one. */
export type ThemePreference = 'system' | 'light' | 'dark'

export const usePrefs = defineStore('prefs', {
    state: () => ({
        locale: readStored<Locale>('harm.locale', 'cs', (value) => value === 'cs' || value === 'en'),
        onlyMine: readStored<boolean>('harm.onlyMine', false, (value) => typeof value === 'boolean'),
        theme: readStored<ThemePreference>('harm.theme', 'system', (value) => value === 'system' || value === 'light' || value === 'dark'),
        /** Whether the side panel is open on a wide screen; on a phone it always starts closed. */
        navigation: readStored<boolean>('harm.navigation', true, (value) => typeof value === 'boolean'),
    }),
    actions: {
        setLocale(locale: Locale) {
            this.locale = locale
            writeStored('harm.locale', locale)
        },
        setOnlyMine(value: boolean) {
            this.onlyMine = value
            writeStored('harm.onlyMine', value)
        },
        setNavigation(open: boolean) {
            this.navigation = open
            writeStored('harm.navigation', open)
        },
        setTheme(theme: ThemePreference) {
            this.theme = theme
            writeStored('harm.theme', theme)
        },
    },
})
